import { motion } from "framer-motion";
import { Calendar, Users, Star, ShieldCheck } from "lucide-react";

const STATS = [
  { icon: Calendar, value: "2019", label: "Serving customers since" },
  { icon: Users, value: "1,000+", label: "Happy customers" },
  { icon: Star, value: "4.8/5", label: "Average rating" },
  { icon: ShieldCheck, value: "Authorized", label: "AntivirusSales.com reseller" },
];

export default function TrustStats() {
  return (
    <section className="bg-[#26395F] text-white border-y border-white/10" data-testid="trust-stats-section">
      <div className="max-w-7xl mx-auto px-6 py-14">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8">
          {STATS.map((s, i) => (
            <motion.div
              key={s.label}
              initial={{ opacity: 0, y: 18 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: i * 0.08 }}
              className="flex flex-col items-center text-center"
              data-testid={`trust-stat-${i}`}
            >
              <s.icon className="h-6 w-6 text-[#60A5FA]" />
              <p className="font-display text-3xl sm:text-4xl font-bold mt-3 tracking-tight">{s.value}</p>
              <p className="text-xs text-white/55 mt-1.5 max-w-[10rem] leading-relaxed">{s.label}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
